// @ts-nocheck
/* eslint-disable */
export const minusLineIcon = {
  data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.16675 9.16669V10.8334H15.8334V9.16669H4.16675Z" fill="currentColor"/></svg>`,
  name: 'minus-line' as const,
};
